import NamedStorage from "./NamedStorage";

export default class SkillStorage {
  private mStorage: NamedStorage;

  constructor() {
    this.mStorage = new NamedStorage("Skills");
  }

  public GetSkillLevel(skillName: string): number {
    return this.mStorage.GetNumber(skillName);
  }

  public SetSkillLevel(skillName: string, level: number): void {
    this.mStorage.Store(skillName, level.toString());
  }

  public GetAllocatedSkillNames(): string[] {
    return this.mStorage.GetArray("AllocatedSkills");
  }

  public AddAllocatedSkill(skillName: string): void {
    const existing = this.GetAllocatedSkillNames();
    if (!existing.includes(skillName)) {
      this.mStorage.StoreInArray("AllocatedSkills", skillName);
    }
  }
}
